module.exports = __webpack_public_path__ + "img/9.0643946b.jpg";